
import Button from '@/components/UI/button/Button.vue';
import DropZone from '@/components/UI/dropZone/DropZone.vue';
import { Header, UploadingFilesObjectForTable } from '@/models/main';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    Button,
    DropZone,
  },
})
export default class UploadAttachments extends Vue {
  @Prop(Array) private readonly PFiles: File[];
  @Prop(String) private readonly warning: string;

  private modal = false;
  private files: File[] = [];
  private filesObjectsForTable: UploadingFilesObjectForTable[] = [];
  private uploadError = '';

  private filesHeaders: Header[] = [
    { text: 'Name', value: 'name' },
    { text: 'Size', value: 'size', align: 'center' },
    { text: 'Delete', value: 'delete', align: 'center' },
  ];

  @Watch('PFiles', { immediate: true, deep: true })
  private watchToPFiles() {
    if (!this.PFiles) {
      this.files = [];
      this.filesObjectsForTable = [];
    }
  }

  private onFilesAdded(files: File[]): void {
    this.uploadError = '';
    this.filesObjectsForTable = [];
    this.files = [...this.files, ...files];
    if (this.files.length > 5) {
      this.uploadError = 'You are only allowed to upload a maximum of 5 files';
      this.files.splice(5);
    }
    this.files.map(file => {
      this.filesObjectsForTable.push({
        name: file.name,
        size: file.size,
      });
    });
  }

  private deleteFiles(item: File): void {
    this.files.splice(this.files.indexOf(item), 1);
    this.filesObjectsForTable.splice(this.files.indexOf(item), 1);
    this.uploadError = '';
  }

  private uploadFiles(): void {
    this.modal = false;
    this.$emit('changeFiles', this.files);
    this.files = [];
    this.filesObjectsForTable = [];
    this.uploadError = '';
  }
}
